var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{staticClass:"avatar",style:(_vm.withElementBackground),attrs:{"src":_vm.pathfinder.avatar}}),(!_vm.hideName)?_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.pathfinder.name))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }